<script>
import Buttons from './Buttons.svelte';
import Navbar from './Navbar.svelte';
import Top from './Top.svelte';
import ScoreResult from './ScoreResult.svelte';
import Triage from './Triage.svelte';
import Training from './Training.svelte';

</script>
<svelte:head>
	<meta charset="utf-8"/>
	<title>Vitals Time</title>
	<link rel="stylesheet"href="https://fonts.googleapis.com/css?family=Roboto Condensed">
	<link rel="stylesheet" href="https://use.typekit.net/vgq0huu.css">
	<link rel="shortcut icon" type="image/svg" href="/pictures/vitalsClock.png">
	<link rel="apple-touch-icon" type="image/png" href="/pictures/vitalsQRTimeClock_appleicon-white.png">
</svelte:head>

<body>
	<section id="home">
	</section>
	<div class="grid">
		<Navbar/>
		<Top/>
		<div id="score">
			<Buttons/>
		</div>
		<Triage/>
		<Training/>
	</div>
</body>

<style>
	:global(body) {
		max-width: 1200px;
		margin-left: auto;
		margin-right: auto; 
	}
	.roboto {
		font-family: Roboto Condensed;
		font-weight: 300;
		font-sytle: normal;
	}
	
	.bebas-regular {
		font-family: bebas-neue-by-fontfabric, sans-serif;
		font-weight: 400;
		font-style: normal;
	}
	
	.bebas-bold {
		font-family: bebas-neue-by-fontfabric,sans-serif;
		font-weight: 700;
		font-style: normal;
	}
	
	.expressway {
		font-family: expressway,sans-serif;
		font-weight: 400;
		font-style: normal;
	}
		
	.grid {
		display: grid;
		grid-template-columns: (auto-fit, minmax(.5vw , 1fr));
	}
	
	
	</style>